module.exports = __webpack_public_path__ + "static/media/iconCopy.45cdb04a.svg";